function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import SingleItem from './shop/SingleItem';
import { API_URL } from './utils/constant';
import _sortBy from 'lodash/sortBy';
import Slider from 'react-slick';
import startCarouselEvents from '../routes/common/carouselEvents';
import PropTypes from 'prop-types';

function SampleNextArrow(props) {
  return /*#__PURE__*/React.createElement("i", {
    className: "slick-next fa fa-angle-right",
    onClick: props.onClick
  });
}

SampleNextArrow.propTypes = {
  onClick: PropTypes.func
};

function SamplePrevArrow(props) {
  return /*#__PURE__*/React.createElement("i", {
    className: "slick-prev fa fa-angle-left",
    onClick: props.onClick
  });
}

SamplePrevArrow.propTypes = {
  onClick: PropTypes.func
};

var NewProductsHomepage = /*#__PURE__*/function (_Component) {
  _inherits(NewProductsHomepage, _Component);

  var _super = _createSuper(NewProductsHomepage);

  function NewProductsHomepage(props) {
    var _this;

    _classCallCheck(this, NewProductsHomepage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchProduct", function (slug) {
      fetch(API_URL + '/products/slug/' + slug.toLowerCase() + '.json', {
        mode: 'cors'
      }).then(function (data) {
        return data.json();
      }).then(function (_product) {
        if (!_product.error) {
          var products = _this.state.products;
          products.push(_product);

          _this.setState({
            products: products
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getNewProduct", function () {
      return document.querySelector('#new-products').getAttribute('new-products');
    });

    _this.productsSlug = _this.getNewProduct().split(', ').filter(function (el) {
      return el != '';
    });
    _this.state = {
      products: []
    };
    _this.settings = {
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow: /*#__PURE__*/React.createElement(SamplePrevArrow, null),
      nextArrow: /*#__PURE__*/React.createElement(SampleNextArrow, null),
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true
        }
      }, {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }]
    };
    return _this;
  }

  _createClass(NewProductsHomepage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.productsSlug.length === 0) {
        document.querySelector('.home-new-products').remove();
      } else {
        this.productsSlug.forEach(function (product, index) {
          _this2.fetchProduct(product, index);
        });
        startCarouselEvents();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var products = this.state.products;
      return products.length > 0 ? /*#__PURE__*/React.createElement(Slider, this.settings, _sortBy(products, 'position').map(function (product) {
        return /*#__PURE__*/React.createElement(SingleItem, {
          isShop: false,
          key: product.id,
          product: product,
          insideRouter: false
        });
      })) : null;
    }
  }]);

  return NewProductsHomepage;
}(Component);

export default NewProductsHomepage;